import { postJSON } from 'bv-fetch';

export default (eventId, legs, components) => (
  postJSON(`/bv_api/bet_builder/progressive_prices/${eventId}`, {
    legs, components,
  })
    .catch(() => {})
);
